import Vue from 'vue';

export default {
  SET_USERS: (state, response) => {
    Vue.set(state, 'users', response.data);
  },
  LOAD_SINGLE_USER: (state, response) => {
    for (const i in response.data.user_logs) {
      response.data.user_logs[i].action_type = response.data.user_logs[i].action_type.charAt(0).toUpperCase() + response.data.user_logs[i].action_type.slice(1);
      response.data.user_logs[i].action_type = response.data.user_logs[i].action_type.split('_').join(' ');
    }
    Vue.set(state, 'singleUser', response.data);
  },
  CLEAR_SINGLE_USER: (state, response) => {
    Vue.set(state, 'singleUser', false);
  },
  SET_PERMISSIONS: (state, response) => {
    Vue.set(state, 'permissions', response.data);
  },
  SET_ROLES: (state, response) => {
    Vue.set(state, 'roles', response.data);
  },
  DELETE_USER: (state, response) => {
    for (let i = 0; i < state.users.length; i++) {
      if (state.users[i].id == response) {
        state.deleted_user = {
          data: state.users[i],
          status: 'success'
        };
        state.users.splice(i, 1);
      }
    }
  },
  ERROR_DELETE_USER: (state, response) => {
    state.deleted_user = {
      data: {},
      status: 'error'
    };
  },
  UPDATE_USER: (state, response) => {
    for (let i = 0; i < state.users.length; i++) {
      if (state.users[i].id == response.id) {
        state.updated_user = {
          data: response,
          status: 'success'
        };
        state.users[i] = response;
      }
    }
  },
  PASSWORD_UPDATE: (state, response) => {
    state.password_change = {
      data: response,
      status: 'success'
    };
  },

  ERROR_UPDATE_USER: (state, response) => {
    state.updated_user = {
      data: {},
      status: 'error'
    };
  },
  ADD_ROLE: (state, response) => {
    state.roles.push(response);
  },
  REMOVE_ROLE: (state, id) => {
    for (let i = 0; i < state.roles.length; i++) {
      if (state.roles[i].id == id) {
        state.roles.splice(i, 1);
        break;
      }
    }
  },
  UPDATE_PERMISSIONS: (state, role) => {
    for (let i = 0; i < state.roles.length; i++) {
      if (state.roles[i].id == role.id) {
        state.roles[i] = role;
        break;
      }
    }
  }
};
